import state from './moduleInvoiceState.js'
import mutations from './moduleInvoiceMutations.js'
import actions from './moduleInvoiceAction.js'
import getters from './moduleInvoiceGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
